import { AnimationState, MarketScanConfig, CompetitorBatchConfig } from './types';

export const INITIAL_STATE: AnimationState = {
  stage: 'idle',
  progress: 0,
  currentStatusText: '',
  statusTextRevealing: false,
  revealedBatches: [],
  visibleCompetitors: [],
  analyzedCompetitorIds: [],
  competitorsVisible: false,
  revealedPackageIds: [],
  shiningPackageId: null,
  expandedPackageId: null,
  tagsVisiblePackageIds: [],
  selectedPackageId: null,
  competitorsMini: false,
  benchmarkVisible: false,
  featurePackVisible: false,
  footerVisible: false,
  isOpen: false,
  quickReveal: false,
  featureModalIdx: null,
  drawerOpenPackageId: null,
  configureScreenOpen: false,
  configureFeatureIdx: 0,
  configureFeatureSelections: {},
  configurePackSaved: false,
};

export const DEFAULT_CONFIG: MarketScanConfig = {
  timing: {
    totalDurationMs: 30000,
    introDurationMs: 2000,
    uiInitDurationMs: 1000,
    introStarDurationMs: 1600,
    introFillDurationMs: 600,
    introFillDelayMs: 500,
    introWavesDurationMs: 1300,
    introWavesDelayMs: 500,
    outroDelayMs: 0,
    packageRevealInitialDelayMs: 200,
    packageRevealStaggerMs: 1000,
    packageExpandDelayMs: 200,
    packageShiningDurationMs: 1000,
    packageTagsDelayMs: 500,
    featurePackDelayMs: 800,
    footerDelayMs: 400,
    competitorRowCollapseMs: 550,
  },
  stages: {
    modelPrep: { startPercent: 0, endPercent: 17, durationMs: 5000 },
    analyzing: { startPercent: 17, endPercent: 77, durationMs: 17500 },
    preparingPacks: { startPercent: 77, endPercent: 100, durationMs: 2500 },
  },
  header: {
    logoSrc: 'https://micros-t.b-cdn.net/Vector%20(1)-1776322906210.png',
    logoText: 'Lumio',
    locationText: '',
  },
  statusTexts: {
    modelPrep: [
      'Initializing market analysis model...',
      'Loading regional data parameters...',
      'Calibrating competitive landscape...',
    ],
    analyzing: [
      'Scanning competitor platforms...',
      'Analyzing pricing structures...',
      'Evaluating feature sets...',
      'Comparing user engagement metrics...',
      'Assessing market positioning...',
    ],
    preparingPacks: [
      'Generating optimized packages...',
      'Finalizing recommendations...',
    ],
    rotationIntervalMs: 3000,
  },
  competitors: [
    {
      delayMs: 500,
      staggerMs: 0,
      loadingDurationMs: 1600,
      competitors: [
        { id: 'c1', name: 'Vlad Casino', logoUrl: 'https://micros-t.b-cdn.net/Frame%201410105293-1775735516449.png' },
      ],
    },
    {
      delayMs: 2600,
      staggerMs: 0,
      loadingDurationMs: 1200,
      competitors: [
        { id: 'c2', name: 'Betano', logoUrl: 'https://micros-t.b-cdn.net/Frame%201410105293%20(2)-1775735516448.png' },
      ],
    },
    {
      delayMs: 4300,
      staggerMs: 0,
      loadingDurationMs: 1400,
      competitors: [
        { id: 'c3', name: 'MrBit', logoUrl: 'https://micros-t.b-cdn.net/Frame%201410105293%20(1)-1775735516444.png' },
      ],
    },
    {
      delayMs: 6200,
      staggerMs: 0,
      loadingDurationMs: 1200,
      competitors: [
        { id: 'c4', name: 'Superbet', logoUrl: 'https://micros-t.b-cdn.net/unnamed%201-1775735516450.png' },
      ],
    },
    {
      delayMs: 7900,
      staggerMs: 0,
      loadingDurationMs: 1000,
      competitors: [{ id: 'c5', name: 'Competitor 5', logoUrl: '' }],
    },
    {
      delayMs: 9400,
      staggerMs: 0,
      loadingDurationMs: 1200,
      competitors: [{ id: 'c6', name: 'Competitor 6', logoUrl: '' }],
    },
    {
      delayMs: 11100,
      staggerMs: 0,
      loadingDurationMs: 1300,
      competitors: [{ id: 'c7', name: 'Competitor 7', logoUrl: '' }],
    },
    {
      delayMs: 12900,
      staggerMs: 0,
      loadingDurationMs: 1200,
      competitors: [{ id: 'c8', name: 'Competitor 8', logoUrl: '' }],
    },
    {
      delayMs: 14600,
      staggerMs: 200,
      loadingDurationMs: 2200,
      competitors: [
        { id: 'c9', name: 'Competitor 9', logoUrl: '' },
        { id: 'c10', name: 'Competitor 10', logoUrl: '' },
      ],
    },
    {
      delayMs: 17300,
      staggerMs: 150,
      loadingDurationMs: 2800,
      competitors: [
        { id: 'c11', name: 'Competitor 11', logoUrl: '' },
        { id: 'c12', name: 'Competitor 12', logoUrl: '' },
        { id: 'c13', name: 'Competitor 13', logoUrl: '' },
      ],
    },
    {
      delayMs: 20600,
      staggerMs: 200,
      loadingDurationMs: 1800,
      competitors: [
        { id: 'c14', name: 'Competitor 14', logoUrl: '' },
        { id: 'c15', name: 'Competitor 15', logoUrl: '' },
      ],
    },
    {
      delayMs: 22900,
      staggerMs: 150,
      loadingDurationMs: 3000,
      competitors: [
        { id: 'c16', name: 'Competitor 16', logoUrl: '' },
        { id: 'c17', name: 'Competitor 17', logoUrl: '' },
        { id: 'c18', name: 'Competitor 18', logoUrl: '' },
        { id: 'c19', name: 'Competitor 19', logoUrl: '' },
      ],
    },
  ],
  benchmark: {
    userPercent: 72,
    marketAveragePercent: 45,
    userLabel: 'Your Package',
    marketLabel: 'Market Average',
    competitorsAnalyzed: 47,
  },
  quickReveal: {
    durationMs: 600,
    staggerMs: 150,
    initialDelayMs: 50,
    blurPx: 10,
    translateYPx: 15,
  },
  packages: [],
  featurePack: [],
};

function batch(
  delayMs: number,
  loadingDurationMs: number,
  items: { id: string; name: string; logoUrl?: string; }[],
  staggerMs = 0,
): CompetitorBatchConfig {
  return { delayMs, staggerMs, loadingDurationMs, competitors: items.map((c) => ({ ...c, logoUrl: c.logoUrl ?? '' })) };
}

const COMPETITORS_MAP: Record<string, CompetitorBatchConfig[]> = {
  international: [
    batch(500, 1400, [{ id: 'i1', name: 'Bet365', logoUrl: 'https://micros-t.b-cdn.net/bet365-1776773394642.png' }]),
    batch(2400, 1800, [{ id: 'i2', name: '888 Casino', logoUrl: 'https://micros-t.b-cdn.net/888casino-1776773394635.jpg' }]),
    batch(4600, 1500, [{ id: 'i3', name: 'LeoVegas', logoUrl: 'https://micros-t.b-cdn.net/leovegas-1776773407680.png' }, { id: 'i4', name: 'Betsson', logoUrl: 'https://micros-t.b-cdn.net/betsson-1776773394643.png' }], 300),
    batch(6500, 1200, [{ id: 'i5', name: 'Unibet', logoUrl: 'https://micros-t.b-cdn.net/unibet-1776773407685.png' }]),
    batch(8100, 2100, [{ id: 'i6', name: 'William Hill', logoUrl: 'https://micros-t.b-cdn.net/william-hill-1776773419503.png' }, { id: 'i7', name: 'Betway', logoUrl: 'https://micros-t.b-cdn.net/betway-1776773394644.png' }], 150),
    batch(10600, 2500, [{ id: 'i8', name: 'PokerStars Casino', logoUrl: 'https://micros-t.b-cdn.net/pokerstars-casino-1776773407683.png' }, { id: 'i9', name: 'Paddy Power', logoUrl: 'https://micros-t.b-cdn.net/paddy-power-1776773407681.png' }, { id: 'i10', name: 'bwin', logoUrl: 'https://micros-t.b-cdn.net/bwin-1776773394645.png' }], 200),
  ],
  mexico: [
    batch(600, 1500, [{ id: 'mx1', name: 'Caliente', logoUrl: 'https://micros-t.b-cdn.net/caliente-1776773394646.png' }]),
    batch(2700, 1700, [{ id: 'mx2', name: 'Strendus', logoUrl: 'https://micros-t.b-cdn.net/strendus-1776773407684.png' }, { id: 'mx3', name: 'Winpot', logoUrl: 'https://micros-t.b-cdn.net/winpot-1776773419504.png' }], 200),
    batch(5000, 1300, [{ id: 'mx4', name: 'Codere', logoUrl: 'https://micros-t.b-cdn.net/codere-1776773407679.png' }]),
    batch(6700, 1400, [{ id: 'mx5', name: '1xBet', logoUrl: 'https://micros-t.b-cdn.net/1xbet-1776773419496.png' }]),
    batch(8500, 1900, [{ id: 'mx6', name: 'Betsson', logoUrl: 'https://micros-t.b-cdn.net/betsson-1776773394643.png' }, { id: 'mx7', name: 'SportiumBet', logoUrl: 'https://www.google.com/s2/favicons?domain=sportiumbet.mx&sz=128' }], 250),
    batch(11000, 2400, [{ id: 'mx8', name: 'Betway', logoUrl: 'https://micros-t.b-cdn.net/betway-1776773394644.png' }, { id: 'mx9', name: 'Big Bola', logoUrl: 'https://micros-t.b-cdn.net/big-bola-1776773419501.jpg' }, { id: 'mx10', name: 'Bodog', logoUrl: 'https://micros-t.b-cdn.net/bodog-1776773419502.png' }], 150),
  ],
  colombia: [
    batch(400, 1600, [{ id: 'co1', name: 'BetPlay', logoUrl: 'https://micros-t.b-cdn.net/betplay-1776773432345.png' }]),
    batch(2500, 1400, [{ id: 'co3', name: 'Rushbet', logoUrl: 'https://micros-t.b-cdn.net/rushbet-1776773432349.png' }, { id: 'co4', name: 'Betsson', logoUrl: 'https://micros-t.b-cdn.net/betsson-1776773394643.png' }], 150),
    batch(4400, 1200, [{ id: 'co6', name: 'Betano', logoUrl: 'https://micros-t.b-cdn.net/betano-1776773432344.png' }]),
    batch(6000, 1800, [{ id: 'co7', name: 'Codere', logoUrl: 'https://micros-t.b-cdn.net/codere-co-1776773432348.png' }, { id: 'co8', name: 'Rivalo', logoUrl: 'https://micros-t.b-cdn.net/rivalo-1776773442232.png' }], 250),
    batch(8200, 1500, [{ id: 'co9', name: 'Zamba', logoUrl: 'https://micros-t.b-cdn.net/zamba-1776773442233.png' }]),
    batch(10100, 2100, [{ id: 'co10', name: 'Luckia', logoUrl: 'https://micros-t.b-cdn.net/luckia-1776773442231.png' }, { id: 'co11', name: 'William Hill', logoUrl: 'https://micros-t.b-cdn.net/william-hill-1776773419503.png' }], 200),
  ],
  united_kingdom: [
    batch(500, 1700, [{ id: 'gb1', name: 'Bet365 Casino', logoUrl: 'https://micros-t.b-cdn.net/bet365-casino-1776773442230.png' }]),
    batch(2600, 1300, [{ id: 'gb2', name: 'Sky Vegas', logoUrl: 'https://micros-t.b-cdn.net/sky-vegas-1776773442232.png' }]),
    batch(4300, 1500, [{ id: 'gb3', name: '888 Casino', logoUrl: 'https://micros-t.b-cdn.net/888casino-uk-1776773419498.jpg' }, { id: 'gb4', name: 'Betway Casino', logoUrl: 'https://micros-t.b-cdn.net/betway-casino-1776773452093.png' }], 200),
    batch(6200, 2000, [{ id: 'gb5', name: 'Ladbrokes Casino', logoUrl: 'https://micros-t.b-cdn.net/ladbrokes-casino-1776773452094.png' }, { id: 'gb6', name: 'William Hill Casino', logoUrl: 'https://micros-t.b-cdn.net/william-hill-casino-1776773452097.png' }, { id: 'gb7', name: 'Paddy Power Casino', logoUrl: 'https://micros-t.b-cdn.net/paddy-power-casino-1776773452096.png' }], 150),
    batch(8700, 1800, [{ id: 'gb8', name: 'LeoVegas', logoUrl: 'https://micros-t.b-cdn.net/leovegas-uk-1776773452095.png' }, { id: 'gb9', name: 'Virgin Games', logoUrl: 'https://micros-t.b-cdn.net/virgin-games-1776773462325.png' }], 250),
    batch(11000, 2200, [{ id: 'gb10', name: 'BetMGM Casino', logoUrl: 'https://micros-t.b-cdn.net/betmgm-casino-1776773462319.png' }, { id: 'gb11', name: 'Mr Green', logoUrl: 'https://micros-t.b-cdn.net/mr-green-1776773462321.png' }], 200),
  ],
  romania: [
    batch(600, 1800, [{ id: 'ro1', name: 'Superbet', logoUrl: 'https://micros-t.b-cdn.net/superbet-1776773462322.png' }, { id: 'ro2', name: 'Betano', logoUrl: 'https://micros-t.b-cdn.net/betano-ro-1776773452090.png' }], 200),
    batch(2900, 1400, [{ id: 'ro3', name: 'Casa Pariurilor', logoUrl: 'https://micros-t.b-cdn.net/casa-pariurilor-1776773462320.png' }]),
    batch(4800, 1600, [{ id: 'ro4', name: 'Winbet', logoUrl: 'https://micros-t.b-cdn.net/winbet-1776773462326.png' }, { id: 'ro5', name: 'Unibet', logoUrl: 'https://micros-t.b-cdn.net/unibet-ro-1776773472346.png' }], 150),
    batch(6800, 1200, [{ id: 'ro6', name: 'Winner', logoUrl: 'https://micros-t.b-cdn.net/winner-1776773432350.jpg' }]),
    batch(8400, 1900, [{ id: 'ro7', name: 'Stanleybet', logoUrl: 'https://micros-t.b-cdn.net/stanleybet-1776773472344.png' }, { id: 'ro8', name: 'Nine Casino', logoUrl: 'https://micros-t.b-cdn.net/nine-casino-1776773472342.png' }], 250),
    batch(10800, 2300, [{ id: 'ro9', name: 'Betonred', logoUrl: 'https://micros-t.b-cdn.net/betonred-1776773472334.png' }, { id: 'ro10', name: 'Fortuna', logoUrl: 'https://micros-t.b-cdn.net/fortuna-1776773472338.png' }], 200),
  ],
};

export function getCompetitorsForCountry(
  countryCode?: string,
  countryName?: string,
): CompetitorBatchConfig[] {
  const code = countryCode?.toUpperCase() ?? '';
  const name = countryName?.toLowerCase() ?? '';

  if (code === 'MEX' || name.includes('mexico')) return COMPETITORS_MAP.mexico;
  if (code === 'COL' || name.includes('colombia')) return COMPETITORS_MAP.colombia;
  if (code === 'GBR' || code === 'UK' || name.includes('united kingdom')) return COMPETITORS_MAP.united_kingdom;
  if (code === 'ROM' || code === 'ROU' || name.includes('romania')) return COMPETITORS_MAP.romania;
  return COMPETITORS_MAP.international;
}

export type MarketTimings = {
  timing: Partial<MarketScanConfig['timing']>;
  stages: Partial<MarketScanConfig['stages']>;
};

const TIMINGS_MAP: Record<string, MarketTimings> = {
  international: {
    timing: {},
    stages: {}
  },
  mexico: {
    timing: { totalDurationMs: 29000, packageRevealStaggerMs: 800 },
    stages: {
      modelPrep: { startPercent: 0, endPercent: 15, durationMs: 4500 },
      analyzing: { startPercent: 15, endPercent: 80, durationMs: 18000 },
      preparingPacks: { startPercent: 80, endPercent: 100, durationMs: 2250 },
    }
  },
  colombia: {
    timing: { totalDurationMs: 27500, packageRevealStaggerMs: 900 },
    stages: {
      modelPrep: { startPercent: 0, endPercent: 20, durationMs: 5500 },
      analyzing: { startPercent: 20, endPercent: 75, durationMs: 16000 },
      preparingPacks: { startPercent: 75, endPercent: 100, durationMs: 2750 },
    }
  },
  united_kingdom: {
    timing: { totalDurationMs: 31000, packageRevealStaggerMs: 1100 },
    stages: {
      modelPrep: { startPercent: 0, endPercent: 18, durationMs: 5250 },
      analyzing: { startPercent: 18, endPercent: 78, durationMs: 18500 },
      preparingPacks: { startPercent: 78, endPercent: 100, durationMs: 2400 },
    }
  },
  romania: {
    timing: { totalDurationMs: 29500, packageRevealStaggerMs: 950 },
    stages: {
      modelPrep: { startPercent: 0, endPercent: 16, durationMs: 4750 },
      analyzing: { startPercent: 16, endPercent: 79, durationMs: 17000 },
      preparingPacks: { startPercent: 79, endPercent: 100, durationMs: 2600 },
    }
  }
};

export function getMarketScanTimingsForCountry(
  countryCode?: string,
  countryName?: string,
): MarketTimings {
  const code = countryCode?.toUpperCase() ?? '';
  const name = countryName?.toLowerCase() ?? '';

  if (code === 'MEX' || name.includes('mexico')) return TIMINGS_MAP.mexico;
  if (code === 'COL' || name.includes('colombia')) return TIMINGS_MAP.colombia;
  if (code === 'GBR' || code === 'UK' || name.includes('united kingdom')) return TIMINGS_MAP.united_kingdom;
  if (code === 'ROM' || code === 'ROU' || name.includes('romania')) return TIMINGS_MAP.romania;
  return TIMINGS_MAP.international;
}
